import React, { useEffect, useRef, useState } from 'react';

import { message, Spin } from 'antd';

import { LoadingOutlined } from '@ant-design/icons';

import imageCompression from 'browser-image-compression';

import classnames from 'classnames';

import styles from './style.module.scss';

const ImagePicker = ({
  title,
  image,
  setImage,
  preview,
  setPreview,
  shouldCompressFile = false,
}) => {
  const inputRef = useRef();

  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (image) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
        setLoading(false);
      };
      reader.readAsDataURL(image);
    } else if (!preview) {
      setPreview(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image]);

  const compressFile = async file => {
    const options = {
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      await setImage(compressedFile);
    } catch (error) {
      message.error('Error while uploading! Please try again.');
    }
  };

  return (
    <div className={styles.container}>
      {title && <div className={styles.title}>{title}</div>}
      {preview ? (
        <button
          className={styles.imagePickerButton}
          type='button'
          onClick={e => {
            e.preventDefault();
            inputRef.current.click();
          }}
        >
          {isLoading ? (
            <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
          ) : (
            <img
              src={preview}
              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
              alt='Upload'
            />
          )}
        </button>
      ) : (
        <button
          className={classnames(styles.imagePickerButton)}
          type='button'
          onClick={event => {
            event.preventDefault();
            inputRef.current.click();
          }}
        >
          Add Image
        </button>
      )}
      <input
        type='file'
        style={{ display: 'none' }}
        ref={inputRef}
        accept='image/*'
        onChange={event => {
          const file = event.target.files[0];
          if (file && file.type.substr(0, 5) === 'image') {
            setLoading(true);
            if (shouldCompressFile) {
              compressFile(file);
            } else {
              setImage(file);
            }
          } else {
            message.error('You can only upload JPG/PNG file!');
          }
        }}
      />
    </div>
  );
};

export default ImagePicker;
